import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsOptional,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { SupplierUpdateDto } from './supplier-update.dto';
import { SUPPLIER_RELATION_MAX_ITEMS } from './supplier-full-create.dto';

/**
 * Body of PATCH /supplier/:id/full. Omitted keys are left untouched;
 * `regionIds` and `representativeUserIds` are desired sets diffed server-side.
 */
export class SupplierFullUpdateDto {
  @ApiPropertyOptional({ type: () => SupplierUpdateDto })
  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => SupplierUpdateDto)
  supplier?: SupplierUpdateDto;

  @ApiPropertyOptional({ type: [String], format: 'uuid' })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(SUPPLIER_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  regionIds?: string[];

  @ApiPropertyOptional({ type: [String], format: 'uuid' })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(SUPPLIER_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  representativeUserIds?: string[];
}
